import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ArtifactBundleListItemDTO } from '../../utils/artifactsApi';
import { ARTIFACT_TYPE_LABELS, formatPublishedAt } from '../../utils/artifactsUi';
import styles from './ArtifactsPage.module.scss';

interface BundleCardProps {
  bundle: ArtifactBundleListItemDTO;
  to?: string;
  onTagClick?: (tag: string) => void;
  workspaceBadge?: string;
}

export function BundleCard({ bundle, to, onTagClick, workspaceBadge }: BundleCardProps) {
  const { t, i18n } = useTranslation();

  const body = (
    <>
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>{bundle.title}</span>
        {bundle.artifact_count > 1 && <span className={styles.count}>{bundle.artifact_count}</span>}
      </div>
      {bundle.description && <div className={styles.description}>{bundle.description}</div>}
      <div className={styles.chips}>
        {workspaceBadge && <span className={styles.workspaceBadge}>{workspaceBadge}</span>}
        {bundle.status !== 'PUBLISHED' && (
          <span className={bundle.status === 'DRAFT' ? styles.draftBadge : styles.archivedBadge}>
            {t(bundle.status === 'DRAFT' ? 'Draft' : 'Archived')}
          </span>
        )}
        {bundle.artifact_types.map((type) => (
          <span key={type} className={styles.typeChip}>
            {t(ARTIFACT_TYPE_LABELS[type])}
          </span>
        ))}
        {bundle.tags.map((tag) =>
          onTagClick ? (
            <button
              key={tag}
              type="button"
              className={styles.tag}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onTagClick(tag);
              }}
            >
              {tag}
            </button>
          ) : (
            <span key={tag} className={styles.tag}>
              {tag}
            </span>
          ),
        )}
      </div>
      <div className={styles.meta}>
        {t('Published')}: {formatPublishedAt(bundle.published_at, i18n.language)}
      </div>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={styles.card}>
        {body}
      </Link>
    );
  }
  return <div className={styles.card}>{body}</div>;
}
